import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolla la pagina in cima a ogni cambio di pathname.
 *
 * React Router NON resetta lo scroll automaticamente (a differenza
 * della navigazione browser tradizionale). Senza questo componente,
 * cliccando su un link da una pagina lunga si rimane allo stesso
 * offset Y nella nuova pagina, dando un'esperienza disorientante.
 *
 * Note:
 *  - usiamo ``window.scrollTo(0, 0)`` (instant) — un comportamento
 *    "smooth" su pagine lunghe risulta lento e confuso.
 *  - rispondiamo solo al cambio di ``pathname`` (NON al ``search``)
 *    così filtri/paginazione che lavorano sui query params NON
 *    forzano uno scroll-to-top indesiderato.
 *  - se in futuro vorremo navigare ad hash (``#sezione``) basterà
 *    estendere la condizione a controllare ``hash``.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
